/** Rhutech Education LMS — product feature data for marketing pages */

export const lmsLiveDemoUrl = 'https://mintcream-mouse-380540.hostingersite.com/';

export const lmsOverview = {
  title: 'Education LMS Platform',
  tagline: 'Full-stack learning management for institutes, coaching centres, and online educators.',
  summary:
    'Web application plus mobile app with exams, courses, live classes, AI study plans, e-commerce, and a complete admin control panel — payments, messaging, and multi-provider AI built in.',
  stats: [
    { value: '20+', label: 'Student modules' },
    { value: '8+', label: 'Admin modules' },
    { value: '5', label: 'Payment gateways' },
    { value: '5+', label: 'AI providers' },
  ],
  techStack: [
    'REST API',
    'JWT Auth',
    'Laravel / PHP',
    'React',
    'Firebase FCM',
    'Razorpay · PayPal · Stripe',
    'Gemini · OpenAI · Claude',
  ],
};

export const lmsStudentFeatures = [
  {
    icon: 'fas fa-chart-pie',
    title: 'Dashboard',
    items: [
      'Overview stats — tests taken, courses enrolled, certificates earned',
      'Recent activity feed',
      'Quick access to all sections',
      'XP and badges display',
    ],
  },
  {
    icon: 'fas fa-file-alt',
    title: 'Tests & Exams',
    items: [
      'Browse tests by exam and subject',
      'Timed test attempts',
      'Results and analytics',
      'Question-wise performance review',
    ],
  },
  {
    icon: 'fas fa-book-open',
    title: 'Courses',
    items: [
      'Browse courses by category',
      'Curriculum and course details',
      'Enrollment and progress tracking',
      'Video lessons and study materials',
    ],
  },
  {
    icon: 'fas fa-chart-line',
    title: 'Analytics',
    items: [
      'Performance trends and charts',
      'Topic-wise strength and weakness',
      'Exam readiness score',
      'AI-generated study plans',
    ],
  },
  {
    icon: 'fas fa-award',
    title: 'Badges & Certificates',
    items: [
      'Earned badges with progress',
      'Certificate gallery',
      'Download certificates',
    ],
  },
  {
    icon: 'fas fa-comments',
    title: 'Chat & Messages',
    items: [
      'Direct messages with users',
      'Group chat',
      'Unread message indicators',
    ],
  },
  {
    icon: 'fas fa-video',
    title: 'Live Classes',
    items: [
      'Scheduled live class calendar',
      'Join live sessions',
      'Class recordings',
      'Class materials',
    ],
  },
  {
    icon: 'fas fa-newspaper',
    title: 'Blog',
    items: ['Educational articles', 'Category filtering', 'Search'],
  },
  {
    icon: 'fas fa-shopping-bag',
    title: 'Shop',
    items: ['Browse products', 'Wishlist and cart', 'Checkout with payment'],
  },
  {
    icon: 'fas fa-user-circle',
    title: 'Profile',
    items: [
      'Personal information',
      'Photo upload',
      'Password change',
      'Account settings',
    ],
  },
  {
    icon: 'fas fa-bell',
    title: 'Notifications',
    items: ['Real-time alerts', 'Filter by type', 'Mark as read'],
  },
];

export const lmsAdminFeatures = [
  {
    icon: 'fas fa-tachometer-alt',
    title: 'Admin Dashboard',
    items: ['Platform overview stats', 'Quick actions', 'Recent activity'],
  },
  {
    icon: 'fas fa-users-cog',
    title: 'User Management',
    items: [
      'View all users',
      'Edit user details',
      'Approve or reject users',
      'Delete accounts',
    ],
  },
  {
    icon: 'fas fa-clipboard-list',
    title: 'Exam Management',
    items: [
      'Create and edit exams',
      'Subjects and topics',
      'Question bank',
      'Test scheduling',
    ],
  },
  {
    icon: 'fas fa-chalkboard-teacher',
    title: 'Course Management',
    items: [
      'Create courses',
      'Upload lessons',
      'Categories',
      'Pricing and subscriptions',
    ],
  },
  {
    icon: 'fas fa-broadcast-tower',
    title: 'Live Classes',
    items: ['Schedule classes', 'Manage recordings', 'Class analytics'],
  },
  {
    icon: 'fas fa-edit',
    title: 'Blog Management',
    items: ['Create and edit posts', 'Categories', 'Publish and draft control'],
  },
  {
    icon: 'fas fa-store',
    title: 'Shop Management',
    items: ['Products', 'Orders', 'Inventory tracking'],
  },
  {
    icon: 'fas fa-cogs',
    title: 'Settings Panel',
    items: [
      'Profile — admin account settings',
      'Email / SMTP configuration',
      'Payment — Razorpay, PayPal, Stripe',
      'WhatsApp integration',
      'SMS — Twilio, MSG91',
      'Homepage CMS',
      'AI — Gemini, Groq, OpenAI, Claude, DeepSeek',
      'Mobile app — Firebase and app config',
      'System info and cache management',
    ],
  },
];

export const lmsTechnicalFeatures = [
  {
    icon: 'fas fa-mobile-alt',
    title: 'Responsive Design',
    description: 'Optimized for desktop, tablet, and mobile.',
  },
  {
    icon: 'fas fa-magic',
    title: 'Modern UI',
    description: 'Glassmorphism, gradients, and smooth animations.',
  },
  {
    icon: 'fas fa-plug',
    title: 'RESTful API',
    description: 'Complete API layer for web and mobile clients.',
  },
  {
    icon: 'fas fa-shield-alt',
    title: 'JWT Authentication',
    description: 'Secure token-based login and session handling.',
  },
  {
    icon: 'fas fa-cloud-upload-alt',
    title: 'File Uploads',
    description: 'Images and documents across courses and profiles.',
  },
  {
    icon: 'fas fa-credit-card',
    title: 'Payments',
    description: 'Razorpay, PayPal, Stripe, and shop checkout.',
  },
  {
    icon: 'fas fa-bell',
    title: 'Push Notifications',
    description: 'Firebase Cloud Messaging for the mobile app.',
  },
  {
    icon: 'fas fa-robot',
    title: 'AI Integration',
    description: 'Multiple AI providers for chat and study plans.',
  },
];
